import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

import LoginV2 from './login_v2/LoginV2';

// NOTE: the classic login (./Login.tsx) is intentionally kept in the tree but no
// longer mounted — LoginV2 is now the sole login screen. Re-import Login here to
// bring it back.
const Auth: React.FC = () => {
  const { url } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${url}/login`}>
        <LoginV2 />
      </Route>
      <Redirect to={`${url}/login`} />
    </Switch>
  );
};

export default Auth;
